import React, { useState, useEffect } from "react";
import LandingPage from "./components/LandingPage";
import GiftCreation from "./components/GiftCreation";
import GiftView from "./components/GiftView";
import SharePage from "./components/SharePage";
import AdminPanel from "./components/AdminPanel";
import TrackOrder from "./components/TrackOrder";
import CustomerEditPage from './components/CustomerEditPage';

function App() {
  const [successCode, setSuccessCode] = useState(null);
  const [view, setView] = useState("landing");
  const [currentGiftId, setCurrentGiftId] = useState("");
  const [magicLink, setMagicLink] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const giftId = params.get("gift");
    const isAdmin = params.get("admin");
    if (giftId) {
      setCurrentGiftId(giftId);
      setView("gift");
    } else if (isAdmin) {
      setView("admin");
    }
  }, []);

  const handleCreateComplete = (response) => {
    const giftId =
      typeof response.id === "string" ? response.id : String(response.id);
    const trackingCode = response.trackingCode;
    const magicLinkUrl = response.magicLink;
    const isFree = response.isFree;

    setCurrentGiftId(giftId);
    setMagicLink(magicLinkUrl);

    if (isFree) {
      setView("share");
    } else {
      setSuccessCode(trackingCode);
      setView("landing");
    }
  };

  const handleCreateNew = () => {
    setCurrentGiftId("");
    setSuccessCode(null);
    setView("landing");
  };

  return (
    <>
      {view === "landing" && (
        <LandingPage
          onStart={() => setView("create")}
          onTrack={() => setView("track")}
          onEdit={() => setView("edit")} 
          successCode={successCode}
        />
      )}

      {view === "create" && <GiftCreation onComplete={handleCreateComplete} />}

      {view === "gift" && <GiftView giftId={currentGiftId} />}

      {view === "share" && (
        <SharePage
          giftId={currentGiftId}
          magicLink={magicLink}
          onCreateNew={handleCreateNew}
        />
      )}

      {view === "admin" && <AdminPanel />}

      {view === "track" && (
        <TrackOrder
          onBack={() => setView("landing")}
          onApproved={(id) => {
            const giftId = typeof id === "string" ? id : String(id);
            setCurrentGiftId(giftId);
            setView("share");
          }}
        />
      )}

      {view === 'edit' && (
        <CustomerEditPage
        onBack={() => setView('landing')}
        />
      )}
    </>
  );
}

export default App;
